export const isPhoneNumberValid = (phoneNumber: string) => {
  if (!phoneNumber) return false;

  // Support E.164 format: +1XXXXXXXXXX
  if (phoneNumber.startsWith('+')) {
    // E.164 format should have a + followed by country code and at least 10 digits
    const e164Pattern = /^\+\d{1,3}\d{10,}$/;
    return e164Pattern.test(phoneNumber);
  }

  // Accepting flexible phone number formats like (303) 217-0796, 303-217-0796, or 1-855-444-1875
  const phonePattern = /^(1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
  return phonePattern.test(phoneNumber);
};

// New function that returns specific validation errors for phone numbers
export const validatePhoneNumber = (
  phoneNumber: string,
): { isValid: boolean; errorMessage?: string } => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return { isValid: false, errorMessage: 'Phone number is required' };
  }

  // Check if it's E.164 format
  if (phoneNumber.startsWith('+')) {
    const e164Pattern = /^\+\d{1,3}\d{10,}$/;
    if (!e164Pattern.test(phoneNumber)) {
      return {
        isValid: false,
        errorMessage:
          'Please enter a valid international phone number (e.g. +12025550123)',
      };
    }
    return { isValid: true };
  }

  // Remove all non-digit characters to count actual digits

  // Check if it matches the expected format (optional leading 1 for US country code)
  const phonePattern = /^(1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
  if (!phonePattern.test(phoneNumber)) {
    return {
      isValid: false,
      errorMessage:
        'Please enter a valid phone number format (e.g. 303-217-0796 or (303) 217-0796)',
    };
  }

  return { isValid: true };
};

export const sanitizePhoneNumber = (phoneNumber: string) => {
  const digits = phoneNumber.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  return `+1${digits}`;
};

export const EmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmailValid = (email: string) => {
  return EmailRegex.test(email);
};
export const normalizePhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return '';
  // Remove +1 prefix if it exists
  return phoneNumber.replace('+1', '');
};
